import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import TitlePage from 'components/TituloPage';
import { setorSistemaListar } from 'routes/paths';
import FormularioSetorSistema from 'containers/Forms/FormSetorSistema/index';
import { formatterSetorBackToFront } from 'utils/formatter/setor';
import * as S from '../styles';
import * as Style from 'components/Style';
import { ENUM_STATUS_ATIVO } from 'utils/consts';

export default function SetorSistemaDetalhar() {
  const setorDetalhar = useSelector(state => state.setor?.setorDetalhar);

  const {
    control,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: formatterSetorBackToFront(setorDetalhar),
  });

  return (
    <S.Page>
      <TitlePage textTitle={'VISUALIZAR SETOR'} backPage={setorSistemaListar} />
      <Style.GlobalCard>
        <FormularioSetorSistema
          errors={errors}
          control={control}
          setValue={setValue}
          setError={setError}
          optionsSituacoes={[
            {
              value: setorDetalhar?.ativo ? ENUM_STATUS_ATIVO.ATIVO.value : ENUM_STATUS_ATIVO.INATIVO.value,
              label: setorDetalhar?.ativo ? ENUM_STATUS_ATIVO.ATIVO.label : ENUM_STATUS_ATIVO.INATIVO.label,
            },
          ]}
          handleSubmit={handleSubmit}
          onSubmit={() => {}}
          disabled={true}
          listaAtendentes={setorDetalhar?.atendentes}
        />
      </Style.GlobalCard>
    </S.Page>
  );
}
